import gql from 'graphql-tag';

export default gql`
  query freeShippingAndReturnsLegalText($loyaltyId: String) {
    freeShippingAndReturnsLegalText(loyaltyId: $loyaltyId) {
      legalCopies {
        title
        copy_title
        description
        link {
          title
          href
        }
      }
    }
  }
`;
